import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import axios from "axios";
import AppLauncher from "../../custom/AppLauncher";
import {
  vector,
  MenuIcon,
  UserIcon,
  UserIconActive,
  AppIcon,
  AppIconActive,
  FujitecLogo,
  logoutimage,
  MasterDataActiveIcon,
  MasterDataIcon,
  DivisionCode,
  DivisionCodeActiveIcon,
  Department,
  DepartmentActiveIcon,
  CategoryActiveIcon,
  CategoryCode,
  LevelActiveIcon,
  LevelIcon,
  DesignActiveIcon,
  Designation,
  ArrowDown,
  ArrowUp,
} from "../../custom/ImageImport.js";
import apiUrl from "../../helpers/endpointservice";
import { Loader } from "../../custom/CommonFunction";
import { useCookies } from "react-cookie";

const TopBar = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const isSuccess = useSelector((state) => state.commonReducer.editCancel);
  const path = window.location.pathname;

  const [pathName, setPathName] = useState("");
  const [appMenu, setAppMenu] = useState(false);
  const [sideMenu, setSideMenu] = useState(false);
  const [sideMenuMob, setSideMenuMob] = useState(false);
  const [isMobile, setisMobile] = useState(false);
  const [isMobile1, setisMobile1] = useState(false);
  const [logout, setLogout] = useState(false);
  const [windowHeight, setwindowHeight] = useState(0);
  const [isMaster, setisMaster] = useState(false);
  const [isAdminAccess, setisAdminAccess] = useState(false);
  const [isLoader, setisLoader] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [imageTxt, setImageTxt] = useState("");
  const [cookies, setCookie, removeCookie] = useCookies("");

  const routeNavigation = (path) => {
    navigate(path);
    if (isMobile) {
      setSideMenuMob(!setSideMenuMob);
      dispatch({ type: "SIDE_MENU", data: false });
    }
  };

  const routeMasterNavigation = (path) => {
    navigate(path);
    if (isMobile) {
      setSideMenuMob(!setSideMenuMob);
      dispatch({ type: "SIDE_MENU", data: false });
    }
  };

  useEffect(() => {
    const intervals = setInterval(() => {
      resize();
    }, 10);
    return () => clearInterval(intervals);
  }, [localStorage.getItem("userId")]);

  useEffect(() => {
    userProfile();
  }, []);

  const resize = () => {
    setwindowHeight(window.innerHeight);
    if (window.innerWidth < 850) {
      setisMobile(true);
    } else {
      setisMobile(false);
    }
    if (window.innerWidth < 300) {
      setisMobile1(true);
    } else {
      setisMobile1(false);
    }
  };

  const pathmenu = (path) => {
    setPathName(path);
  };

  const sideMenuClick = () => {
    setSideMenu(!sideMenu);
    dispatch({ type: "SIDE_MENU", data: !sideMenu });
  };

  const openLogoutModal = () => {
    setLogout(!logout);
  };

  const LogoutYes = async () => {
    setisLoader(true);
    const cookieOptions = {
      domain: process.env.REACT_APP_COMMON_DOMAIN,
      path: "/",
    };
    removeCookie("refreshTokenAC", cookieOptions);
    if (localStorage.getItem("userDataDecode") != undefined) {
      let emailData = JSON.parse(localStorage.getItem("userDataDecode"))?.email;

      if (emailData != undefined) {
        axios
          .put(
            apiUrl.TokenInvalidate +
              "?user_email=" +
              emailData +
              "&applicationName=" +
              encodeURIComponent("Global Admin")
          )
          .then((response) => {
            setisLoader(false);
            if (response?.status === 200) {
              logoutFunction();
            } else {
              logoutFunction();
            }
          })
          .catch((error) => {
            setisLoader(false);
            if (error?.response?.status === 403) {
              logoutFunction();
            }
          });
      } else {
        setisLoader(false);
        logoutFunction();
      }
    } else {
      setisLoader(false);
      logoutFunction();
    }
    localStorage.clear();
    sessionStorage.clear();
  };

  const logoutFunction = () => {
    // axios.defaults.headers.common = {};
    // window.location.href = process.env.REACT_APP_LOGOUT;
    localStorage.clear();
    const redirectUri = process.env.REACT_APP_REDIRECTURI;
    const clientId = process.env.REACT_APP_CLIENTID;
    const scope = process.env.REACT_APP_SCOPE;
    const accesstype = process.env.REACT_APP_ACCESS_TYPE;
    const prompt = process.env.REACT_APP_PROMPT;
    const authUrl =
      process.env.REACT_APP_AUTHURL +
      `?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&access_type=${accesstype}&prompt=${"consent"}`;
    window.location.href = authUrl;
  };

  const userProfile = () => {
    // if(localStorage.getItem("userDataDecode")?.email){
    const userId = JSON.parse(localStorage.getItem("userDataDecode"))?.email;
    //  const userId = "kevin.fleming@mail.com"
    if (userId) {
      const userRaw = userId.split(/[@]/);

      const user = userRaw[0].split(/[._-]/);

      if (user?.length === 1) {
        const user1 = user[0].charAt(0).toUpperCase() + user[0].slice(1);
        setFirstName(user1);
        setLastName(null);

        setImageTxt(user[0].charAt(0).toUpperCase());
      } else if (user?.length > 1) {
        const user1 = user[0].charAt(0).toUpperCase() + user[0].slice(1);
        const user2 = user[1].charAt(0).toUpperCase() + user[1].slice(1);
        setFirstName(user1);
        setLastName(user2);

        setImageTxt(user[0].charAt(0).toUpperCase());
      }
    }
  };

  return (
    <>
      <Loader loader={isLoader} />
      <AppLauncher isOpen={appMenu} setisOpen={setAppMenu} />
      <table className="box">
        <tbody>
          <tr>
            <td>
              <div className="row px-3">
                <div className="col-6 d-flex align-items-center">
                  <img
                    src={vector}
                    className="cursor-pointer"
                    onClick={() => setAppMenu(!appMenu)}
                  />
                  {isMobile == false && (
                    <img src={FujitecLogo} className="pl-20 pt-2" />
                  )}
                  <label
                    className={`${isMobile ? "pl-10" : "pl-30"} label-style`}
                  >
                    Admin&nbsp;Center
                  </label>
                </div>
                <div className="col-6 d-flex align-items-center justify-content-end">
                  <div
                    className="d-flex cursor-pointer align-items-center"
                    onClick={() => setLogout(!logout)}
                  >
                    {isMobile == false && (
                      <label className="cursor-pointer label-user pl-20">
                        {/* {
                          JSON.parse(localStorage.getItem("userDataDecode"))
                            ?.name
                        } */}
                        {JSON.parse(localStorage.getItem("userDataDecode"))
                          ?.name || `${firstName} ${lastName}`}
                      </label>
                    )}
                    <div
                      className={` ${
                        isMobile ? "ml-10" : ""
                      } ${`circle cursor-pointer`}`}
                    >
                      {/* {JSON.parse(
                        localStorage.getItem("userDataDecode")
                      )?.name?.charAt(0)} */}
                      {JSON.parse(
                        localStorage.getItem("userDataDecode")
                      )?.name?.charAt(0) || imageTxt}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      {logout == true && (
        <div className="logout-style">
          <div
            className="pt-3 pl-10 pr-2 pb-2 logout-label text-overflow"
            title={JSON.parse(localStorage.getItem("userDataDecode"))?.email}
          >
            {JSON.parse(localStorage.getItem("userDataDecode"))?.email}
          </div>
          <div
            className="pt-2 pl-10 pr-2 pb-2 cursor-pointer logout-labelcursor-pointer"
            data-bs-toggle="modal"
            data-bs-target="#logoutPage"
            onClick={openLogoutModal}
          >
            <img src={logoutimage} />
            &nbsp;&nbsp;Log out
          </div>
        </div>
      )}
      {isMobile == false && (
        <>
          <div
            className={sideMenu == true ? "side-bar-menu" : "side-bar"}
            id="sideBarMenu"
            style={{ height: windowHeight - 1 }}
          >
            <img
              className="pl-20 pt-10 pb-10 cursor-pointer"
              src={MenuIcon}
              onClick={sideMenuClick}
            />
            <br />{" "}
            <div
              className={`${sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"} ${
                path == "/users" ? "sidebar-active" : ""
              } d-flex pl-20 cursor-pointer`}
              onClick={() => routeNavigation("/users")}
              title={sideMenu == true ? "Users" : ""}
            >
              <img src={path == "/users" ? UserIconActive : UserIcon} />
              {sideMenu == false && (
                <div
                  className={`${
                    path == "/users" ? "fw-bold" : ""
                  } pl-20 pr-20 text-overflow app-label`}
                >
                  Users
                </div>
              )}
            </div>
            <div
              className={`${sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"} ${
                path == "/application" ? "sidebar-active" : ""
              } d-flex pl-20 cursor-pointer`}
              onClick={() => routeNavigation("/application")}
              title={sideMenu == true ? "Applications" : ""}
            >
              <img src={path == "/application" ? AppIconActive : AppIcon} />
              {sideMenu == false && (
                <div
                  className={`${
                    path == "/application" ? "fw-bold" : ""
                  } pl-20 pr-20 text-overflow app-label`}
                >
                  Applications
                </div>
              )}
            </div>
            <div
              className={`${sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"} ${
                path == "/divisioncode" ||
                path == "/departmentcode" ||
                path == "/categorycode" ||
                path == "/level" ||
                path == "/designation" ||
                path == "/mainrole" ||
                path == "/supportingrole"
                  ? "sidebar-active"
                  : ""
              } d-flex pl-20 cursor-pointer`}
              onClick={() => setisMaster(!isMaster)}
              title={sideMenu == true ? "Master Data" : ""}
            >
              <img
                src={
                  path == "/divisioncode" ||
                  path == "/departmentcode" ||
                  path == "/categorycode" ||
                  path == "/level" ||
                  path == "/designation" ||
                  path == "/mainrole" ||
                  path == "/supportingrole"
                    ? MasterDataActiveIcon
                    : MasterDataIcon
                }
              />
              {sideMenu == false && (
                <>
                  <div
                    className={`${
                      path == "/divisioncode" ||
                      path == "/departmentcode" ||
                      path == "/categorycode" ||
                      path == "/level" ||
                      path == "/designation" ||
                      path == "/mainrole" ||
                      path == "/supportingrole"
                        ? "fw-bold"
                        : ""
                    } pl-20 pr-20 text-overflow app-label`}
                  >
                    Master Data
                  </div>
                  <img
                    className="pl-60"
                    src={isMaster == false ? ArrowUp : ArrowDown}
                  />
                </>
              )}
            </div>
            {isMaster == false && (
              <>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${path == "/" ? "sidebar-active" : ""} ${
                    sideMenu == true ? "pl-20" : "pl-55"
                  } d-flex cursor-pointer`}
                  onClick={() => routeMasterNavigation("/divisioncode")}
                  title={sideMenu == true ? "Division code" : ""}
                >
                  <img
                    src={
                      path == "/divisioncode"
                        ? DivisionCodeActiveIcon
                        : DivisionCode
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == "/divisioncode" ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Division code
                    </div>
                  )}
                </div>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${path == "" ? "sidebar-active" : ""} ${
                    sideMenu == true ? "pl-20" : "pl-55"
                  } d-flex cursor-pointer`}
                  onClick={() => routeMasterNavigation("/departmentcode")}
                  title={sideMenu == true ? "Department code" : ""}
                >
                  <img
                    src={
                      path == "/departmentcode"
                        ? DepartmentActiveIcon
                        : Department
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == "/departmentcode" ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Department code
                    </div>
                  )}
                </div>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${path == "/" ? "sidebar-active" : ""} ${
                    sideMenu == true ? "pl-20" : "pl-55"
                  } d-flex cursor-pointer`}
                  onClick={() => routeMasterNavigation("/categorycode")}
                  title={sideMenu == true ? "Category code" : ""}
                >
                  <img
                    src={
                      path == "/categorycode"
                        ? CategoryActiveIcon
                        : CategoryCode
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == "/categorycode" ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Category code
                    </div>
                  )}
                </div>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${path == "/" ? "sidebar-active" : ""} ${
                    sideMenu == true ? "pl-20" : "pl-55"
                  } d-flex cursor-pointer`}
                  onClick={() => routeMasterNavigation("/level")}
                  title={sideMenu == true ? "Level" : ""}
                >
                  <img src={path == "/level" ? LevelActiveIcon : LevelIcon} />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == "/level" ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Level
                    </div>
                  )}
                </div>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${path == "/" ? "sidebar-active" : ""} ${
                    sideMenu == true ? "pl-20" : "pl-55"
                  } d-flex cursor-pointer`}
                  onClick={() => routeMasterNavigation("/designation")}
                  title={sideMenu == true ? "Designation name" : ""}
                >
                  <img
                    src={
                      path == "/designation" ? DesignActiveIcon : Designation
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == "/designation" ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Designation name
                    </div>
                  )}
                </div>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${path == "/" ? "sidebar-active" : ""} ${
                    sideMenu == true ? "pl-20" : "pl-55"
                  } d-flex cursor-pointer`}
                  onClick={() => routeMasterNavigation("/mainrole")}
                  title={sideMenu == true ? "Main role" : ""}
                >
                  <img
                    src={path == "/mainrole" ? DesignActiveIcon : Designation}
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == "/mainrole" ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Main role
                    </div>
                  )}
                </div>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${path == "/" ? "sidebar-active" : ""} ${
                    sideMenu == true ? "pl-20" : "pl-55"
                  } d-flex cursor-pointer`}
                  onClick={() => routeMasterNavigation("/supportingrole")}
                  title={sideMenu == true ? "Supporting role" : ""}
                >
                  <img
                    src={
                      path == "/supportingrole" ? DesignActiveIcon : Designation
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == "/supportingrole" ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Supporting role
                    </div>
                  )}
                </div>
              </>
            )}
            {/* </>
            )} */}
          </div>
        </>
      )}
      {isMobile == true && (
        <div className="row mobile-sidebar position-fixed">
          <div className="col-12">
            <img
              className="pl-20 pb-10 cursor-pointer pt-15"
              src={MenuIcon}
              onClick={() => setSideMenuMob(!sideMenuMob)}
            />
            <br />
          </div>
        </div>
      )}
      {isMobile == true && sideMenuMob == true && (
        <>
          <div
            className={`${
              isMobile1 ? "sidebar-list-mob" : "sidebar-list"
            } position-fixed `}
            style={{ height: windowHeight - 1 }}
          >
            <img
              className="pl-20 pb-10 cursor-pointer pt-15"
              src={MenuIcon}
              onClick={() => setSideMenuMob(!sideMenuMob)}
            />
            <br />{" "}
            <div
              className={`${"pt-10 pb-10"} ${
                path == "/users" ? "sidebar-active" : ""
              } d-flex pl-20 cursor-pointer`}
              onClick={() => routeNavigation("/users")}
            >
              <img src={path == "/users" ? UserIconActive : UserIcon} />
              <div
                className={`${
                  path == "/users" ? "fw-bold" : ""
                } pl-20 pr-20 text-overflow app-label`}
              >
                Users
              </div>
            </div>
            <div
              className={`${"pt-10 pb-10"} ${
                path == "/application" ? "sidebar-active" : ""
              } d-flex pl-20 cursor-pointer`}
              onClick={() => routeNavigation("/application")}
            >
              <img src={path == "/application" ? AppIconActive : AppIcon} />
              <div
                className={`${
                  path == "/application" ? "fw-bold" : ""
                } pl-20 pr-20 text-overflow app-label`}
              >
                Applications
              </div>
            </div>
            <div
              className={`${sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"} ${
                path == "/divisioncode" ||
                path == "/departmentcode" ||
                path == "/categorycode" ||
                path == "/level" ||
                path == "/designation" ||
                path == "/mainrole" ||
                path == "/supportingrole"
                  ? "sidebar-active"
                  : ""
              } d-flex pl-20 cursor-pointer`}
              onClick={() => setisMaster(!isMaster)}
            >
              <img
                src={
                  path == "/divisioncode" ||
                  path == "/departmentcode" ||
                  path == "/categorycode" ||
                  path == "/level" ||
                  path == "/designation" ||
                  path == "/mainrole" ||
                  path == "/supportingrole"
                    ? MasterDataActiveIcon
                    : MasterDataIcon
                }
              />
              {sideMenu == false && (
                <>
                  <div
                    className={`${
                      path == "/divisioncode" ||
                      path == "/departmentcode" ||
                      path == "/categorycode" ||
                      path == "/level" ||
                      path == "/designation" ||
                      path == "/mainrole" ||
                      path == "/supportingrole"
                        ? "fw-bold"
                        : ""
                    } pl-20 pr-20 text-overflow app-label`}
                  >
                    Master Data
                  </div>
                  <img
                    className="pl-60"
                    src={isMaster == false ? ArrowUp : ArrowDown}
                  />
                </>
              )}
            </div>
            {isMaster == false && (
              <>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${
                    path == "/" ? "sidebar-active" : ""
                  } d-flex pl-55 cursor-pointer`}
                  onClick={() => routeMasterNavigation("/divisioncode")}
                >
                  <img
                    src={
                      path == "/divisioncode"
                        ? DivisionCodeActiveIcon
                        : DivisionCode
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == "/divisioncode" ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Division code
                    </div>
                  )}
                </div>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${
                    path == "" ? "sidebar-active" : ""
                  } d-flex pl-55 cursor-pointer`}
                  onClick={() => routeMasterNavigation("/departmentcode")}
                >
                  <img
                    src={
                      path == "/departmentcode"
                        ? DepartmentActiveIcon
                        : Department
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == "/departmentcode" ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Department code
                    </div>
                  )}
                </div>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${
                    path == "/" ? "sidebar-active" : ""
                  } d-flex pl-55 cursor-pointer`}
                  onClick={() => routeMasterNavigation("/categorycode")}
                >
                  <img
                    src={
                      path == "/categorycode"
                        ? CategoryActiveIcon
                        : CategoryCode
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == "/categorycode" ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Category code
                    </div>
                  )}
                </div>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${
                    path == "/" ? "sidebar-active" : ""
                  } d-flex pl-55 cursor-pointer`}
                  onClick={() => routeMasterNavigation("/level")}
                >
                  <img src={path == "/level" ? LevelActiveIcon : LevelIcon} />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == "/level" ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Level
                    </div>
                  )}
                </div>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${
                    path == "/" ? "sidebar-active" : ""
                  } d-flex pl-55 cursor-pointer`}
                  onClick={() => routeMasterNavigation("/designation")}
                >
                  <img
                    src={
                      path == "/designation" ? DesignActiveIcon : Designation
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == "/designation" ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Designation name
                    </div>
                  )}
                </div>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${
                    path == "/" ? "sidebar-active" : ""
                  } d-flex pl-55 cursor-pointer`}
                  onClick={() => routeMasterNavigation("/mainrole")}
                >
                  <img
                    src={path == "/mainrole" ? DesignActiveIcon : Designation}
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == "/mainrole" ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Main role
                    </div>
                  )}
                </div>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${
                    path == "/" ? "sidebar-active" : ""
                  } d-flex pl-55 cursor-pointer`}
                  onClick={() => routeMasterNavigation("/supportingrole")}
                >
                  <img
                    src={
                      path == "/supportingrole" ? DesignActiveIcon : Designation
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == "/supportingrole" ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Supporting role
                    </div>
                  )}
                </div>
              </>
            )}
            {/* </>
            )} */}
          </div>
        </>
      )}

      <div
        id="logoutPage"
        className="modal fade modal-top"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-all">
          <div className="modal-content px-4">
            <div className="row">
              <div className="col-12">
                <div className="px-1 py-3 align-middle border-bottom-modal">
                  <img src={logoutimage} className="top-margin" />
                  <label className="modal-title text-20-bold pl-10">
                    Logout
                  </label>
                </div>
              </div>
            </div>
            <div>
              <div>
                <label className="text-16-bold pt-3">
                  Are you sure you want to log out?
                </label>
              </div>
            </div>
            <div className="py-3 text-center">
              <button
                className="cancel-button text-12-bold px-4 py-2"
                data-bs-dismiss="modal"
              >
                No
              </button>
              <button
                className="success-button text-12-bold px-4 py-2 ml-10"
                data-bs-dismiss="modal"
                onClick={LogoutYes}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopBar;
